import React from "react";
import "./Reveal.scss";

const CONFETTI_PARTICLES = [
  { x: "-48vw", drift: "10vw", delay: "0s", rotate: "-180deg" },
  { x: "-40vw", drift: "6vw", delay: "2.1s", rotate: "220deg" },
  { x: "-32vw", drift: "8vw", delay: "0.9s", rotate: "-240deg" },
  { x: "-24vw", drift: "5vw", delay: "1.8s", rotate: "170deg" },
  { x: "-16vw", drift: "7vw", delay: "2.4s", rotate: "-200deg" },
  { x: "-8vw", drift: "4vw", delay: "3s", rotate: "260deg" },
  { x: "0vw", drift: "-4vw", delay: "0.2s", rotate: "-260deg" },
  { x: "8vw", drift: "-7vw", delay: "1.1s", rotate: "210deg" },
  { x: "16vw", drift: "-5vw", delay: "1.5s", rotate: "-190deg" },
  { x: "24vw", drift: "-8vw", delay: "3.9s", rotate: "240deg" },
  { x: "32vw", drift: "-6vw", delay: "2.7s", rotate: "-230deg" },
  { x: "40vw", drift: "-10vw", delay: "1.6s", rotate: "200deg" },
  { x: "48vw", drift: "-12vw", delay: "3.3s", rotate: "-210deg" },
  { x: "-44vw", drift: "9vw", delay: "4.5s", rotate: "250deg" },
  { x: "-48vw", drift: "10vw", delay: "0.4s", rotate: "-180deg" },
  { x: "-40vw", drift: "6vw", delay: "1.2s", rotate: "220deg" },
  { x: "-32vw", drift: "8vw", delay: "4.1s", rotate: "-240deg" },
  { x: "-24vw", drift: "5vw", delay: "3.1s", rotate: "170deg" },
  { x: "-16vw", drift: "7vw", delay: "2.2s", rotate: "-200deg" },
  { x: "-8vw", drift: "4vw", delay: "0.5s", rotate: "260deg" },
  { x: "0vw", drift: "-4vw", delay: "2.9s", rotate: "-260deg" },
  { x: "8vw", drift: "-7vw", delay: "4.2s", rotate: "210deg" },
  { x: "16vw", drift: "-5vw", delay: "3.6s", rotate: "-190deg" },
  { x: "24vw", drift: "-8vw", delay: "3.8s", rotate: "240deg" },
  { x: "32vw", drift: "-6vw", delay: "2.5s", rotate: "-230deg" },
  { x: "40vw", drift: "-10vw", delay: "1.7s", rotate: "200deg" },
  { x: "48vw", drift: "-12vw", delay: "3.8s", rotate: "-210deg" },
  { x: "-44vw", drift: "9vw", delay: "4.3s", rotate: "250deg" },
];

const Reveal = (props) => {
  const {
    redirectButtonText,
    redirectButtonLink,
    redirectButtonColor,
    matchedCount,
    totalPairs,
    client,
    from,
  } = props;

  const isAirFrance = client === "airfrance";

  const handleClick = () => {
    if (isAirFrance) window.location.reload();
    else window.open(redirectButtonLink, "_blank");
  };

  const pairMessage =
    matchedCount === totalPairs
      ? `Perfect, you matched all ${totalPairs} pairs!`
      : `You matched ${matchedCount} out of ${totalPairs} pairs!`;

  return (
    <div className="Reveal" style={{ marginTop: isAirFrance ? "20px" : 0 }}>
      <div className="reveal-confetti-layer" aria-hidden="true">
        {CONFETTI_PARTICLES.map((particle, index) => (
          <span
            key={`reveal-confetti-${index}`}
            className="reveal-confetti-piece"
            style={{
              "--confetti-x": particle.x,
              "--confetti-drift": particle.drift,
              "--confetti-delay": particle.delay,
              "--confetti-rotate": particle.rotate,
            }}
          />
        ))}
      </div>
      {from === "memory" ? (
        <div className="memory-message">{pairMessage}</div>
      ) : null}
      {isAirFrance ? (
        <div className="air-france-message">
          Enjoy your gift from Air France and join us soon to enjoy the many
          amenities offered in Premium.
        </div>
      ) : null}
      <div
        className="reveal-button"
        onClick={redirectButtonLink ? handleClick : null}
        style={{
          backgroundColor: redirectButtonColor,
        }}
      >
        {redirectButtonText}
      </div>
    </div>
  );
};

export default Reveal;
